/*
 * @Author: CN\chenhb47 chenhb47@annto.com.cn
 * @Date: 2022-10-10 10:58:51
 * @LastEditors: 付鑫宇 111
 * @LastEditTime: 2023-03-03 15:50:10
 * @FilePath: \logistics-fe-otp\src\modules\otp\api\carSchedulingDialog.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '@/utils/http';

// 车牌
export const getLicensePlate = data => {
    return request({
        url: `/api-srm-web/basis/supplierCarInfos/getEnableCarListBySupplierCode`,
        method: 'post',
        data
    });
};
// 新车牌
export const getNewLicensePlate = data => {
    return request({
        url: `/api-tms/dispatch/resource/car/query`,
        method: 'post',
        data
    });
};

// 调车单号
export const getOrderNo = data => {
    return request({
        url: `api-tms/dispatch/ntp/order/list`,
        method: 'post',
        data
    });
};

// 司机
export const getDriverName = data => {
    return request({
        url: `/api-srm-web/basis/supplierDriverInfo/getEnableDriverListBySupplierCode`,
        method: 'post',
        data
    });
};
// 新司机
export const getNewDriverName = data => {
    return request({
        url: `/api-tms/dispatch/resource/driver/query`,
        method: 'post',
        data
    });
};
// 新车牌接口，关联车型，采购渠道
export const getLicensePlateApi = data => {
    return request({
        url: `/api-tms/base/carInfo/page`,
        method: 'post',
        data
    });
};

// 承运商
export const getSearchBySupplier = data => {
    return request({
        url: `/api-tms/srm/supplier/search`,
        method: 'post',
        data
    });
};
// 会计主体
export const getInvoiceUnitName = (data) => {
    return request({
        url: `/api-tms/contract/info/matchContract`,
        method: 'post',
        data
    });
};
// 目标成本
export const getTargetCost = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeCostSearch`,
        method: 'post',
        data
    });
};

// 白名单接口
export const getWhiteListApi = (params) => {
    return request({
        url: `/api-opms/opms/whitelist/list`,
        method: 'get',
        params
    });
};
// 白名单接口
export const isLingDanApi = (data) => {
    return request({
        url: `/api-tms/dispatch/isLingDan`,
        method: 'post',
        data
    });
};

export const isSiteWhiteListApi = (data) => {
    return request({
        url: `/api-tms/dispatch/reverse/process/whiteList/flag?siteCode=${data}`,
        method: 'get'
    });
};
// 根据承运商编码精准查询信息
// export const searchBySupplierCodeOrNameCn = (params, tenantCode) => {
//     return request({
//         url: `/api-mdm/ebSupplier/selectBySupplierCode`,
//         method: 'get',
//         params,
//         headers: {
//             tenantCode
//         }
//     });
// };
export const searchBySupplierCodeOrNameCn = (data) => {
    return request({
        url: `/api-tms/srm/supplier/search`,
        method: 'post',
        data
    });
};
// 判断供应商是否直控运力
export const getIsControlTransportToOpt = (data) => {
    return request({
        url: `/api-tms/srm/getIsControlTransportToOpt`,
        method: 'post',
        data
    });
};
// 获取采购渠道
export const getProcurementChannelListApi = (data) => {
    return request({
        url: `/api-tms/srm/supplier/procurementChannel/query`,
        method: 'post',
        data
    });
};
// 查询快递单号校验
export const judgeExpressApi = (data) => {
    return request({
        url: `/api-tms/dispatch/judgeExpress`,
        method: 'post',
        data
    });
};
// 根据网络调车单号,查询消息信息
export const getNtpManagerOrderNoTipApi = (data) => {
    return request({
        url: `/api-tms/ntp/deploy/get`,
        method: 'post',
        data
    });
};
// 判断装载率是否低于百分之50校验，通过就返回true
export const verifyLoadingRate = (data) => {
    return request({
        url: `/api-tms/dispatch/loadingRate/verify`,
        method: 'post',
        data
    });
};
// 网络调车逆向时，当时个体车且是自调车时，取接口返回的成本
export const getNtpManagerOrderComputerCostApi = (data) => {
    return request({
        url: `/api-tms/ntp/deploy/computerCost`,
        method: 'post',
        data
    });
};

// 查询运力信息
export const getIsDirectCarrier = (data) => {
    return request({
        url: `/api-tms/newDispatchTool/directCarrier/query`,
        method: 'post',
        data
    });
};
// 获取自助打印标识
export const getSelfPrintApi = (data) => {
    return request({
        url: `/api-antms/common/self/print/config/match`,
        method: 'post',
        data
    });
};
// 排车获取运输收入接口
export const getOutContractIncomeApi = (data) => {
    return request({
        url: `/api-tms/outContractIncome/iflow/cal`,
        method: 'post',
        data
    });
};
